<style lang="less" scoped>
@import url('./index.less');
</style>

<template>
  <div class="experts_detail_container">
    <div class="experts_detail_wrap">
      <div class="title">{{detail.title}}</div>
      <!-- <div class="author_wrap">
        <div class="default_img">
          <img :src="logo" >
        </div>
        <div class="author">
          <div class="author_info">{{detail.author}}</div>
          <div class="publidh_date">{{detail.publish_date_format}}</div>
        </div>
      </div> -->
      <div class="content">
        <p v-for="(item,index) in detail.content_display" :key="index">{{item}}</p>
      </div>
      <div class="article_wrap">
        <div class="label">参考来源:</div>
        <div class="url_list">
          <div class="url_item">{{detail.source}}</div>
        </div>
      </div>
      <div><Chatbot /></div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import HSlogo from '@/assets/images/hssz.png'
import { HttpRequest} from 'utils/'
export default {
  data() {
    return {
      logo:'',
      id:'',
      detail:{}
    }
  },
  created() {
    document.title = '专家问答'
    this.logo = HSlogo
    this.id = this.$route.query.id
    this.getData()
  },
  methods:{
    async getData() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      });
      const res = await HttpRequest({
        url:`/professional/quiz/${this.id}/`
      })
      Toast.clear()
      console.log(res)
      this.detail = res
    }
  }
}
</script>